import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-background pt-8 md:pt-16" data-testid="hero-section">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="w-full flex justify-center px-0 md:px-4"
      >
        <div className="relative w-full max-w-7xl">
          <img
            src="https://customer-assets.emergentagent.com/job_1f5fe23d-d8f2-4d46-9a46-cbe5186179e5/artifacts/funyv5ek_0A13FCB2-C238-41B7-9C18-1C12F06E5487.png"
            alt="Hooyo's Place Early Education & Childcare - Diverse children learning and playing in a colorful classroom"
            className="w-full h-auto object-contain"
            data-testid="hero-image"
          />
          {/* Left fade */}
          <div className="absolute top-0 left-0 bottom-0 w-[14%] md:w-[20%] bg-gradient-to-r from-background via-background/85 via-40% to-transparent pointer-events-none" />
          {/* Right fade */}
          <div className="absolute top-0 right-0 bottom-0 w-[14%] md:w-[20%] bg-gradient-to-l from-background via-background/85 via-40% to-transparent pointer-events-none" />
          {/* Top fade */}
          <div className="absolute top-0 left-0 right-0 h-[8%] md:h-[12%] bg-gradient-to-b from-background via-background/70 to-transparent pointer-events-none" />
          {/* Bottom fade */}
          <div className="absolute bottom-0 left-0 right-0 h-[18%] md:h-[22%] bg-gradient-to-t from-background via-background/80 to-transparent pointer-events-none" />
          {/* Corner fills */}
          <div className="absolute top-0 left-0 w-[25%] h-[20%] pointer-events-none" style={{ background: 'radial-gradient(ellipse at 0% 0%, hsl(38,50%,97%) 30%, transparent 70%)' }} />
          <div className="absolute top-0 right-0 w-[25%] h-[20%] pointer-events-none" style={{ background: 'radial-gradient(ellipse at 100% 0%, hsl(38,50%,97%) 30%, transparent 70%)' }} />
          <div className="absolute bottom-0 left-0 w-[25%] h-[25%] pointer-events-none" style={{ background: 'radial-gradient(ellipse at 0% 100%, hsl(38,50%,97%) 30%, transparent 70%)' }} />
          <div className="absolute bottom-0 right-0 w-[25%] h-[25%] pointer-events-none" style={{ background: 'radial-gradient(ellipse at 100% 100%, hsl(38,50%,97%) 30%, transparent 70%)' }} />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
